// A desktop AI client (02-DESIGN/09-gateway/02-the-oauth-face.md § the
// address, § the one-line add, and the bootstrap, § what the console shows;
// 01-the-console.md § Apps, for a desktop AI client): the pure parts the
// Apps, Toolkits and Sign-in pages share. A toolkit has two addresses at the
// gateway — the bare face path, which an app reaches with its key, and the
// same path under the workspace's slug, which a person's own client reaches
// by signing them in at the workspace's sign-in. Nothing here is a key:
// there is none for a desktop client.

/** TOOLKIT_PLACEHOLDER stands in for a toolkit's name until the person picks one. */
export const TOOLKIT_PLACEHOLDER = "<toolkit>";

function base(gateway: string): string {
  return gateway.replace(/\/+$/, "");
}

/** appAddress is a toolkit's address for an app: `<gateway>/mcp/<toolkit>`. */
export function appAddress(gateway: string, toolkit: string): string {
  return `${base(gateway)}/mcp/${toolkit}`;
}

/**
 * personAddress is a toolkit's address for a person's own client, the
 * workspace in the path: `<gateway>/<slug>/mcp/<toolkit>`.
 */
export function personAddress(gateway: string, slug: string, toolkit: string): string {
  return `${base(gateway)}/${slug}/mcp/${toolkit}`;
}

/** AddLine is the one line a common client is given to add a toolkit. */
export interface AddLine {
  client: string;
  line: string;
}

/**
 * addLines are the one lines for the common clients that add an MCP server
 * from a command: no header, no key, nothing but the address.
 */
export function addLines(name: string, address: string): AddLine[] {
  return [
    { client: "Claude Code", line: `claude mcp add --transport http ${name} ${address}` },
    {
      client: "VS Code",
      line: `code --add-mcp '${JSON.stringify({ name, type: "http", url: address })}'`,
    },
  ];
}

/**
 * LOOPBACK_REDIRECTS are the redirects a desktop client returns the browser
 * to, on any port it picks, with the callback path the common clients use;
 * they go on the provider's native client, the one the terminal signs in
 * with, so the workspace's sign-in gains no client id.
 */
export const LOOPBACK_REDIRECTS = ["http://127.0.0.1/callback", "http://localhost/callback"] as const;

/** clientSignsIn is the sentence beside the line, with the workspace's name. */
export function clientSignsIn(workspace: string): string {
  return `Your client opens the browser on ${workspace}'s sign-in; there is no key.`;
}

/** AN_APP says what an app's key is for: what cannot open a browser to sign in. */
export const AN_APP =
  "An app gets a key, for what cannot open a browser: a pipeline, a script, an agent on a server.";

/** WHICH_WAY says, in the person's words, which way in is for what. */
export const WHICH_WAY = `Your AI client signs in as you. ${AN_APP}`;
